module.exports = __webpack_public_path__ + "img/线下见面会.e1aeb2f4.png";